import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-ai',
  templateUrl: './about-us-ai.component.html',
  styleUrls: ['./about-us-ai.component.scss']
})
export class AboutUsAiComponent implements OnInit {

  data = [
    {
      img: 'assets/img/culture.png',
      header: 'Передова нейронаука',
      description: 'AI-асистент Anima створений на основі новітніх відкриттів у доказовій психології та нейронауці. Ми не покладаємося на абстрактні опитування чи суб’єктивні звіти — замість цього аналізуємо закономірності поведінки ваших очей, щоб побачити, що насправді відбувається всередині.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Технологія відстеження погляду',
      description: 'Ваші очі розкажуть більше, ніж слова.\n' +
          'Anima використовує вебкамеру, щоб відстежувати тонкі зміни у поведінці вашого погляду – просто в браузері, без спеціального обладнання. Це дозволяє фіксувати ваш психічний стан у реальному часі — точніше (80-93%) й швидше, ніж традиційні методи.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Повна конфіденційність',
      description: 'Ми не записуємо ніяких відео чи фото. Ми збираємо тільки координати погляду. Усі процеси – захищені та анонімізовані. Ми дотримуємося суворих міжнародних стандартів безпеки, щоб ви могли досліджувати свій внутрішній світ без жодних сумнівів.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Уважний AI-асистент',
      description: 'Anima – не просто інструмент. Це ваш особистий асистент, що здатний розпізнавати параметри вашої уваги та надавати точні й корисні відгуки – без повчання чи упереджень.\n' +
          'Ми допомагаємо краще розуміти свій стан у моменті й м’яко орієнтуємо вас у ньому для досягнення максимального психологічного добробуту.',
      num: '04'
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
